<div class="contratos">
  <div class="container-fluid wrapper-content">
    <div class="ibox">
      <div class="ibox-title">
        <h2 class="title">
          Contratos
        </h2>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-safra" class="control-label">Safra</label>
              <select
                name="filter-safra"
                id="filter-safra"
                class="form-control"
                ng-options="safra.descricao for safra in $root.safras track by safra.id"
                ng-model="$ctrl.safra"
                ng-change="$ctrl.loadContratos()"
              ></select>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-atividade" class="control-label">Atividade</label>
              <select
                name="filter-atividade"
                id="filter-atividade"
                class="form-control"
                ng-options="atividade.descricao for atividade in $ctrl.atividades track by atividade.id"
                ng-model="$ctrl.atividade"
                ng-change="$ctrl.loadContratos()"
              >
                <option value="">Todas</option>
              </select>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-gleba" class="control-label">Talhão</label>
              <select
                name="filter-gleba"
                id="filter-gleba"
                class="form-control"
                ng-options="gleba.descricao for gleba in $root.currentPropriedade.glebas track by gleba.id"
                ng-model="$ctrl.gleba"
                ng-change="$ctrl.loadContratos()"
              >
                <option value="">Todas</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12">
            <p class="text-cinza text-center" ng-show="$ctrl.loading">
              <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando contratos...
            </p>
            <div class="text-cinza text-center" ng-show="!$ctrl.loading && $ctrl.itensContratos.length === 0">
              <h3>
                Nenhum contrato encontrado
              </h3>
            </div>

            <table class="table table-striped" ng-show="!$ctrl.loading && $ctrl.itensContratos.length !== 0">
              <thead>
              <tr>
                <th>Data</th>
                <th>Nr. Contrato</th>
                <th>Cultura</th>
                <th>Quantidade</th>
                <th>Valor Unitário</th>
                <th>Valor Total</th>
                <th>Talhões</th>
                <th>Status</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr ng-repeat="contratoItem in $ctrl.itensContratos track by contratoItem.id">
                <td>{{contratoItem.contrato.data | date:'dd/MM/yyyy'}}</td>
                <td>{{contratoItem.contrato.numero}}</td>
                <td>{{contratoItem.item_estoque.descricao}}</td>
                <td>{{contratoItem.quantidade | number: 2}} {{contratoItem.unidade.abreviatura}}</td>
                <td>{{contratoItem.valor_unitario | number: 2}}</td>
                <td>{{contratoItem.valor_total | number: 2}}</td>
                <td>{{contratoItem.glebas_names}}</td>
                <td class="action-column">
                  <div class="btn-group">
                    <a ng-click="$ctrl.assignGlebas(contratoItem)" class="btn btn-primary">
                      <i class="fa fa-edit"></i>
                      Atribuir talhões
                    </a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
